import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  selectShippingOption,
  refreshShippingOptions
} from 'shared/components/cart/actions';
import { setShippingOption as setCheckoutShippingOption } from 'components/checkoutPage/actions';
import scrollIntoView from 'scroll-into-view';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import { withConjunction } from 'shared/utils';
import { Warning, DangerWarning } from 'scy/Warning';
import { Small } from 'scy/text';
import { RadioList, RadioListItem } from 'scy/RadioList';
import { LoadingButton } from 'scy/buttons';
import { flex } from 'scy/flex.mod.scss';
import { width100 } from 'scy/utils.mod.scss';
import { relative } from 'scy/position.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import Icon from './Icon';
import Title from './Title';

let Expanded = class Expanded extends React.Component {
  componentDidMount() {
    const containerRect = this.container.getBoundingClientRect();
    if (containerRect && containerRect.top < 0) scrollIntoView(this.container);

    if (this.props.shippingOptions.length === 0) {
      return this.props.refreshShippingOptions();
    } else if (!this.props.selectedShippingOption) {
      return this.preselectOption();
    }
  }

  componentDidUpdate() {
    if (this.props.cartProducts.length === 0) {
      this.props.collapse();
    }
  }

  preselectOption() {
    const option = this.props.shippingOptions[0];
    if (option && _.isEmpty(this.props.selectedOption)) {
      return this.selectOption(option);
    }
  }

  selectOption(option) {
    return this.props.selectShippingOption(option, { checkout: true });
  }

  handleSubmit(e) {
    e.preventDefault();
    return this.props
      .setCheckoutShippingOption(this.props.cartShippingOption)
      .then(() => this.props.collapse());
  }

  render() {
    const shippingOptions = this.props.shippingOptions || [];
    const selectedOption =
      this.props.cartShippingOption || this.props.selectedOption || {};
    const loading = this.props.shippingOptionsLoading || this.props.cartLoading;
    const noAvailabledOptions = !loading && !this.props.shippingOptions.length;
    const disabled =
      _.isEmpty(selectedOption) ||
      this.props.shippingOptionsLoading ||
      noAvailabledOptions;
    const specialOrderProducts = this.props.cartProducts.filter(
      product => product.special_order
    );

    return (
      <div ref={div => (this.container = div)}>
        <div className={flex}>
          <Icon />
          <div className={margin.bottom_xs}>
            <Title />

            <Small tag="div">We ship orders out Monday-Friday</Small>
          </div>
        </div>

        <form onSubmit={e => this.handleSubmit(e)}>
          {!!specialOrderProducts.length && (
            <Warning>
              {withConjunction(
                specialOrderProducts.map(product =>
                  `${product.title} ${product.subtitle}`.trim()
                )
              )}{' '}
              may require 2-3 days to process.
            </Warning>
          )}

          {this.props.shippingOptionsLoading ? (
            <div className={`${relative} ${padding.lg}`}>
              <LoadingSpinner black />
            </div>
          ) : noAvailabledOptions ? (
            <DangerWarning className={margin.bottom_sm}>
              Sorry, product(s) in your cart aren’t available at this address.
              Please update your cart or change your address.
            </DangerWarning>
          ) : (
            <RadioList className={margin.bottom_sm}>
              {shippingOptions.map(option => {
                return (
                  <RadioListItem
                    key={`${option.name} ${option.price}`}
                    name={'shipping'}
                    id={`shipping_${option.name.replace(/\s+/g, '-')}`}
                    checked={selectedOption.name === option.name}
                    onChange={() => this.selectOption(option)}
                    title={option.name}
                    aside={option.price ? `$${option.price.toFixed(2)}` : null}
                  />
                );
              })}
            </RadioList>
          )}

          <div className="row">
            <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
              <LoadingButton
                type="submit"
                className={width100}
                disabled={disabled}
                loading={this.props.cartLoading}
              >
                Continue
              </LoadingButton>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

Expanded = connect(
  state => ({
    address: state.address,
    shippingOptions: state.cart.shippingOptions || [],
    shippingOptionsLoading: state.cart.shippingOptionsLoading,
    selectedOption: state.checkout.shippingOption,
    cartShippingOption: state.cart.selectedShippingOption,
    cartFee: state.cart.fee,
    cartProducts: state.cart.products,
    cartLoading: state.cart.loading
  }),
  {
    refreshShippingOptions,
    selectShippingOption,
    setCheckoutShippingOption
  }
)(Expanded);

export default Expanded;
